import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex flex-1 items-center" }
const _hoisted_3 = { class: "mr-2 flex space-x-1" }
const _hoisted_4 = { class: "mr-2 flex space-x-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "mt-2 sm:flex sm:justify-between" }
const _hoisted_8 = { class: "sm:flex sm:space-x-4" }
const _hoisted_9 = { class: "flex items-center text-sm text-gray-500" }
const _hoisted_10 = { class: "flex items-center text-sm text-gray-500 sm:ml-0 sm:mt-0" }
const _hoisted_11 = { class: "mt-2 flex flex-wrap justify-between border-t pt-3" }
const _hoisted_12 = { class: "mb-1 grid gap-3 sm:mb-0 sm:grid-cols-3" }
const _hoisted_13 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_16 = { class: "truncate" }
const _hoisted_17 = { class: "truncate" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex items-center space-x-1 text-xs text-gray-600" }

import { PropType } from 'vue';
import { ContactModel, Permission } from '@/types';
import { MailIcon, PhoneIcon } from '@heroicons/vue/solid';
import { PencilAltIcon } from '@heroicons/vue/outline';
import UiAuditInfo from '@/components/UiAuditInfo.vue';
import { formatDateAsString } from '@/utils/datetime';
import { applyPhoneMask } from '@/utils/number';
import { ContactSentiment, contactSentimentMap } from '@/utils/contactSentiment';
import { ContactHealthScoreBadge } from '.';
import { ContactHealthScoreStats } from '@/types/metrics/ContactHealthScore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactListItem',
  props: {
    modelValue: {
        type: Object as PropType<ContactModel>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const sentiment = (() => {
    const lastSentiment = props.modelValue.lastSentiment;
    if (!lastSentiment) return null;
    return contactSentimentMap[lastSentiment as ContactSentiment];
})();

const healthScore: ContactHealthScoreStats = {
    score: 59,
    analysis:
        'A relação com a Fintrust Capital vinha estável sob tratativas de integração e renovação contratual, mas sofreu uma queda recente de satisfação que reduziu o health score para 59. O principal ponto de atrito foi uma indisponibilidade de 40 minutos no sistema em horário de pico, o que gerou forte insatisfação e a exigência de reembolso e de um relatório de causa raiz. Como próxima ação recomendada, deve-se formalizar o envio do relatório técnico de causa raiz e conceder o crédito na fatura solicitado para restabelecer a confiança do cliente antes da renovação de fim de ano.',
};

return (_ctx: any,_cache: any) => {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_CONTACT) ? 'RouterLink' : 'span'), {
            to: {
                        name: 'ViewContactById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    },
            class: "text-md text-primary truncate font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.modelValue.name), 1)
            ]),
            _: 1
          }, 8, ["to"])),
          _createVNode(_component_UiIsActiveBadge, {
            "model-value": __props.modelValue,
            class: "ml-2 text-xs"
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(ContactHealthScoreBadge), { "health-score": healthScore })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$can(_unref(Permission).VIEW_CONTACT_TIMELINE))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                        name: 'ViewContactTimelineById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "white",
                    "text-variant": "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('contact.list.actions.viewTimeline')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.$can(_unref(Permission).EDIT_CONTACT))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                class: "rounded-full",
                to: {
                        name: 'EditContactById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createVNode(_unref(MailIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(__props.modelValue.emails.find((e) => e.isMain)?.email || _ctx.$t('contact.list.noEmail')), 1)
          ]),
          _createElementVNode("p", _hoisted_10, [
            _createVNode(_unref(PhoneIcon), {
              class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(applyPhoneMask)(__props.modelValue.phones.find((p) => p.isMain)!.number) || ''), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.list.owner')) + ": ", 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(__props.modelValue.ownerUser.name), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.list.lastInteraction')) + ": ", 1),
            (__props.modelValue.lastInteraction)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(formatDateAsString)(__props.modelValue.lastInteraction?.toString(), 'DD/MM/YYYY')), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(formatDateAsString)(__props.modelValue.lastInteraction?.toString(), 'HH:mm:ss')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_unref(sentiment))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(sentiment).face), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(_unref(sentiment).label)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(UiAuditInfo, { "model-value": __props.modelValue }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})